import { bound } from "@frui.ts/helpers/dist";
import { watchBusy } from "@frui.ts/screens";
import { Router, ScreenBase } from "@frui.ts/screens/dist";
import BusyWatcher from "@frui.ts/screens/dist/structure/busyWatcher";
import download from "downloadjs";
import { computed, observable } from "mobx";
import AccountingRepository from "repositories/accountingRepository";
import LocalizationService from "services/localizationService";
import { Modules } from "config";
import fileNameWithDate from "../../../utils/fileNameWithDate";

const navigationName = "accounting-templates";

@Router.registerRoute({ name: Router.Self, route: navigationName })
export default class AccountingTemplatesViewModel extends ScreenBase {
  @observable busyWatcher = new BusyWatcher();
  @observable fileResponse: any = undefined;

  constructor(private localizationService: LocalizationService, private repository: AccountingRepository) {
    super();
    this.navigationName = navigationName;
  }

  @computed
  get name() {
    return this.translate("name");
  }

  @bound
  @watchBusy
  async onDownloadClick() {
    this.fileResponse = await this.repository.templates();
    download(
      this.fileResponse.data,
      fileNameWithDate("sablony-ucetnich-predpisu", "xlsx", new Date()),
      this.fileResponse.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
  }

  translate(code: string) {
    return this.localizationService.translateModule(Modules.finance, `accountingTemplates.${code}`);
  }
}
